import { useCallback, useState } from 'react'
import { withStyles } from '@aura/components/styles'
import Form from '@aura/forms/form'
import { Trans, useTranslation } from 'react-i18next'
import Box from '@aura/components/box'
import Grid from '@aura/components/grid'
import Button from '@aura/components/button'
import Link from '@aura/components/link'
import Radio from '@aura/components/radio'
import { useAuraThemeSwitcher } from '@aura/components/themes'
import QRCode from 'react-qr-code'
import Typography from '@aura/components/typography'
import PropTypes from 'prop-types'
import Languages from '../../../../constants/languages'
import RegistrationContainerNew from '../../../../components/registration-container-new'
import { deviceTypes, downloadLink, mobileDeviceTypes, mobileIcons } from './constants/device-type'
import providerType from './constants/provider-type'
import formFields, { initialValues } from './constants/form-fields'
import styles from './styles'


const Component = ({
    appName,
    classes,
    onBack,
    onNext,
    provider,
    title,
    verbiage
}) => {
    const { theme } = useAuraThemeSwitcher()
    const { DEVICE_TYPE } = formFields
    const { i18n, t: translate } = useTranslation()
    const [ deviceType, setDeviceType ] = useState(deviceTypes.IPHONE)
    const [ downloadURL, setDownloadURL ] = useState(downloadLink[provider][deviceTypes.IPHONE])
    const [ selectedValue, setSelectedValue ] = useState(deviceTypes.IPHONE)
    const [ hoveredType, setHoveredType ] = useState(null)
    const [ selectedLanguage, setSelectedLanguage ] = useState(i18n.language)

    const handleTypeChange = useCallback((e, text) => {
        setDeviceType(text)
        setDownloadURL(downloadLink[provider][text])
    })

    const titleDeviceType = translate('mfa')

    const validate = values => {
        const errors = {}

        if (!values[DEVICE_TYPE]) {
            errors[DEVICE_TYPE] = translate('required')
        }

        console.log('errors', errors)
        return errors
    }
    const handleChange = useCallback(text => {
        setDeviceType(text)
        setSelectedValue(text)
        setDownloadURL(downloadLink[provider]?.[text] || '')
        setSelectedLanguage(i18n.language)
    }, [ provider ])

    const footerContent = (
        <Grid className={classes.buttonContainer} container item md={12} xs={12}>
            <Grid container className={classes.actionRow} justify="space-between">
                <Button
                    className={classes.buttonSkip}
                    onClick={onBack}
                    variant="text">{translate('back')}
                </Button>
                <Button
                    className={classes.buttonSubmit}
                    onClick={onNext}
                    variant="contained">{translate('next')}
                </Button>
            </Grid>
        </Grid>
    )

    return (
        <RegistrationContainerNew {...{ footerActions: footerContent, title: titleDeviceType, verbiage: translate(`authenticatorOptions.${verbiage}`) }}>
            <Form className={classes.formContainer} {...{
                enableReinitialize: true,
                initialValues: initialValues,
                onSubmit: onNext,
                validate
            }}>
                <div className={classes.fieldsContainer}>
                    {Object.keys(mobileDeviceTypes).map(type => (
                        <Box
                            key={type}
                            className={`${classes.deviceOption} 
                                ${(hoveredType === type || selectedValue === type) && classes.deviceOptionSelected} 
                                ${selectedLanguage === Languages.FRENCH && classes.deviceOptionOptionFr}
                                ${deviceType === type && classes.deviceOptionSelected}`
                            }
                            onMouseEnter={() => setHoveredType(type)}
                            onMouseLeave={() => setHoveredType(null)}
                            onClick={() => handleChange(type)}
                        >
                            <Box className={classes.deviceNameContainer}>
                                <Box className={classes.deviceIconBox}>
                                    <img className={classes.deviceLogo} src={mobileIcons[theme.palette.mode][type]} />
                                    <Typography className={classes.deviceTitle}>{mobileDeviceTypes[type]}</Typography>
                                </Box>
                            </Box>
                            <Box className={classes.radioButton}>
                                <Radio
                                    className={classes.radio}
                                    checked={deviceType === type}
                                    onChange={() => handleChange(type)}
                                    value={mobileDeviceTypes[type]}
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': mobileDeviceTypes[type] }}
                                />
                            </Box>
                        </Box> 
                    ))}
                    <Box className={classes.downloadContainer}>
                        <Box className={classes.downloadVerbiageBox}>
                            <Typography className={classes.download}>{translate('deviceType.scan1')}<Link className={classes.downloadLink} href={downloadURL} underline="none" target="_blank" rel="noopener noreferrer">{translate('deviceType.scan2')} {deviceType === deviceTypes.IPHONE ? 'App Store' : 'Google Play' }</Link> <Trans>{translate('deviceType.scan3', { appName: appName, deviceType: deviceType === deviceTypes.IPHONE ? 'iOS' : 'android'  })}</Trans></Typography>
                            <Box component="p" className={classes.warningLine}>{translate('mfaEnrollment.verbiage07')} </Box>
                        </Box>
                        <Box className={classes.qrCodeWrapper}>
                            <QRCode size={120} viewBox={'0 0 256 256'} value={downloadURL} />
                        </Box>
                    </Box>
                </div>
            </Form>
        </RegistrationContainerNew>
    )
}

Component.displayName = 'DeviceType'

Component.defaultProps = {
    provider: providerType.OKTA
}

Component.propTypes = {
    appName: PropTypes.string,
    classes: PropTypes.shape({
        button: PropTypes.object,
        loader: PropTypes.object,
        root: PropTypes.object
    }),
    onBack: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    provider: PropTypes.string.isRequired,
    title: PropTypes.string,
    verbiage: PropTypes.string,
}

export default withStyles(Component, styles)
